import React, { useCallback } from 'react';
import styles from './styles/navbar.ms.options.vehicle.mobile.module.scss';
import { prettifyNumber } from 'helpers';
import { useDispatch, useSelector } from 'react-redux';
import {
  SetUpdateMarketScanPopup,
  SetPolicyDetailsSection,
} from 'actions/navbar-actions';
import classNames from 'classnames';
import { IAppState } from 'types';

interface INavBarMarkScanOptionsVehicleProps {
  policySubTypeName: string;
  excess?: number;
  amount?: number;
  excessContents?: number | boolean;
  amountContents?: number | boolean;
  excessHome?: number | boolean;
  amountHome?: number | boolean;
  thirdPartyScan: boolean;
  showCoverType: boolean;
}

const NavBarMarkScanOptionsMobile = ({
  policySubTypeName,
  excess,
  amount,
  thirdPartyScan,
  showCoverType,
  excessContents,
  amountContents,
  excessHome,
  amountHome,
}: INavBarMarkScanOptionsVehicleProps) => {
  const dispatch = useDispatch();
  const isDetailsPopup = useSelector(
    (state: IAppState) => state.navBar.showPolicyDetails,
  );

  const openUpdateMarketScanDetailsPopup = useCallback(() => {
    dispatch(SetPolicyDetailsSection(true));
    dispatch(SetUpdateMarketScanPopup(true));
  }, []);

  return (
    <div
      className={classNames(
        styles.container,
        thirdPartyScan && styles.centreContent,
      )}
    >
      {showCoverType && (
        <div
          className={styles.section}
          onClick={openUpdateMarketScanDetailsPopup}
        >
          <span
            className={classNames(
              styles.link,
              !thirdPartyScan && styles.coverType,
            )}
          >
            {policySubTypeName}
          </span>
        </div>
      )}

      {!thirdPartyScan && amount && (
        <div
          className={styles.section}
          onClick={openUpdateMarketScanDetailsPopup}
        >
          <span className={styles.label}>Value:</span>{' '}
          <span className={styles.link}>{`$${prettifyNumber(amount)}`}</span>
        </div>
      )}

      {excess && (
        <div
          className={styles.section}
          onClick={openUpdateMarketScanDetailsPopup}
        >
          <span className={styles.label}>Excess:</span>{' '}
          <span className={styles.link}>{`$${prettifyNumber(excess)}`}</span>
        </div>
      )}

      {amountHome && (
        <div
          className={styles.section}
          onClick={openUpdateMarketScanDetailsPopup}
        >
          <span className={styles.label}>House:</span>{' '}
          <span
            className={styles.link}
          >{`$${prettifyNumber(amountHome)}`}</span>
        </div>
      )}

      {amountContents && (
        <div
          className={styles.section}
          onClick={openUpdateMarketScanDetailsPopup}
        >
          <span className={styles.label}>Contents:</span>{' '}
          <span
            className={styles.link}
          >{`$${prettifyNumber(amountContents)}`}</span>
        </div>
      )}

      {!showCoverType && (
        <div
          className={styles.section}
          onClick={openUpdateMarketScanDetailsPopup}
        >
          <span className={styles.link}>
            {isDetailsPopup ? 'Less info' : 'More info'}
          </span>
        </div>
      )}
    </div>
  );
};

export default NavBarMarkScanOptionsMobile;
